import React from 'react';
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';


class Price extends React.Component {
 
  render() { 
    return <PricingTable  highlightColor='#1976D2'>
    
    <PricingSlot highlighted onClick={this.submit} buttonText='SUBMİT' title='BASIC' priceText='$?/month'>
        <PricingDetail> <b>1</b> projects</PricingDetail>
        <PricingDetail> <b>15 GB</b> storage</PricingDetail>
        <PricingDetail> <b>1-2</b> users</PricingDetail>
        <PricingDetail> <b>Time tracking</b></PricingDetail>
    </PricingSlot>
    <PricingSlot  onClick={this.submit} buttonText='SUBMİT' title='PROFESSIONAL' priceText='$?/month'>
        <PricingDetail> <b>1-3</b> projects</PricingDetail>
        <PricingDetail> <b>30 GB</b> storage</PricingDetail>
        <PricingDetail> <b>2-5</b> users</PricingDetail>
        <PricingDetail> <b>Time tracking</b></PricingDetail>
    </PricingSlot>
    <PricingSlot  onClick={this.submit} buttonText='SUBMİT' title='ENTERPRISE' priceText='$?/month'>
        <PricingDetail> <b>Unlimited</b> projects</PricingDetail>
        <PricingDetail> <b>75 GB</b> storage</PricingDetail>
        <PricingDetail> <b>Unlimited</b> users</PricingDetail>
        <PricingDetail> <b>Time tracking</b></PricingDetail>
    </PricingSlot>
</PricingTable>
  
  }
}

export default Price ;  